export default __webpack_public_path__ + "static/media/Alchemy Chains 4.d3e86853.png";